import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { getUA } from "react-device-detect";
import {
  Footer,
  LinkNavigation,
  LinkNavigationGroup
} from "@common/DynamicUikit";
import { isMultiLangCountry } from "@util/country";
import { replacePlaceholder } from "@util/helpers";
import { COUNTRY, LANGUAGE } from "@type/index";
import { FR_UserAgent } from "@config/common";

const PublicFooter = () => {
  const { t } = useTranslation();
  const { language, region } = useParams();

  const handleSwitchLanguage = (from: LANGUAGE, to: LANGUAGE) => {
    if (to !== language) {
      const url = replacePlaceholder(window.location.href, {
        [`/${region}/${from}`]: `/${region}/${to}`
      });
      window.location.replace(url);
    }
  };

  // CA
  const CALanguageList = [
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.FR, LANGUAGE.EN)}
      selected={language === LANGUAGE.EN}
    >
      {t("text_locale_en")}
    </LinkNavigation>,
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.EN, LANGUAGE.FR)}
      selected={language === LANGUAGE.FR}
    >
      {t("text_locale_fr")}
    </LinkNavigation>
  ];

  // ID
  const IDLanguageList = [
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.ID, LANGUAGE.EN)}
      selected={language === LANGUAGE.EN}
    >
      {t("text_locale_en")}
    </LinkNavigation>,
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.EN, LANGUAGE.ID)}
      selected={language === LANGUAGE.ID}
    >
      {t("text_locale_id")}
    </LinkNavigation>
  ];

  // TH
  const THLanguageList = [
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.TH, LANGUAGE.EN)}
      selected={language === LANGUAGE.EN}
    >
      {t("text_locale_en")}
    </LinkNavigation>,
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.EN, LANGUAGE.TH)}
      selected={language === LANGUAGE.TH}
    >
      {t("text_locale_th")}
    </LinkNavigation>
  ];

  // VN
  const VNLanguageList = [
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.VI, LANGUAGE.EN)}
      selected={language === LANGUAGE.EN}
    >
      {t("text_locale_en")}
    </LinkNavigation>,
    <LinkNavigation
      element="button"
      onClick={() => handleSwitchLanguage(LANGUAGE.EN, LANGUAGE.VI)}
      selected={language === LANGUAGE.VI}
    >
      {t("text_locale_vi")}
    </LinkNavigation>
  ];

  const getLanguageDetails = () => {
    switch (region) {
      case COUNTRY.CA:
        return CALanguageList;
      case COUNTRY.ID:
        return IDLanguageList;
      case COUNTRY.TH:
        return THLanguageList;
      case COUNTRY.VN:
        return VNLanguageList;
      default:
        return <></>;
    }
  };

  const isInApp: boolean = getUA.indexOf(FR_UserAgent) > -1;

  return isMultiLangCountry(region as COUNTRY) && !isInApp ? (
    <Footer
      copyrightRow={t("text_copyright")}
      footerLinksContainer={
        <LinkNavigationGroup
          variant="horizontal"
          labelId={t("text_styling_book_header_title")}
        >
          {getLanguageDetails()}
        </LinkNavigationGroup>
      }
    />
  ) : (
    <Footer copyrightRow={t("text_copyright")} />
  );
};

export default PublicFooter;
